import { Building2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { AssetWithStats } from '@/common/asset';
import { cn } from '@/lib/utils';

/** The asset's organization name, shown on list cards when assets of several organizations are listed together. */
export function AssetOrganizationLabel({ asset, className }: { asset: AssetWithStats; className?: string }) {
	if (!asset.organization?.name) {
		return null;
	}
	return (
		<div
			className={cn('flex items-center gap-1.5 text-xs font-medium text-muted-foreground min-w-0', className)}
			title={asset.organization.name}
		>
			<Building2 className="size-3.5 shrink-0" />
			<span className="line-clamp-1">{asset.organization.name}</span>
		</div>
	);
}

/** Grey "Inactive" tag for an asset whose organization is deactivated (its data is read-only). */
export function AssetInactiveBadge({ asset, className }: { asset: AssetWithStats; className?: string }) {
	const { t } = useTranslation();
	if (asset.organization?.enabled !== false) {
		return null;
	}
	return (
		<span
			className={cn(
				'shrink-0 rounded border px-1.5 py-0.5 text-xs font-medium',
				// Explicit greys: the theme's muted tokens are near-white in light mode
				'border-zinc-300 bg-zinc-100 text-zinc-600 dark:border-zinc-700 dark:bg-zinc-800 dark:text-zinc-300',
				className,
			)}
			title={t('assets.organization.inactiveAssetHint')}
		>
			{t('common.states.inactive')}
		</span>
	);
}
